import type { LanguageContextType } from "~/context/LanguageContext";

import ar from "./ar";
import de from "./de";
import en from "./en";
import fr from "./fr";

export type Dict = typeof en;

const dict: Record<LanguageContextType["lang"], Dict> = { en, fr, de, ar };

export default dict;
